export let tipsPaneHeader = "VT2Iac";
export let editorPaneHeader = "k0Thub";
export let helpPaneHeader = "W5WMjc";
export default {tipsPaneHeader,editorPaneHeader,helpPaneHeader};